import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'
import { ContextMenuStatusEnum } from './enums/ContextMenuStatus.enum'
import { ContextMenuOption } from './dtos/ContextMenuOption.dto'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContextMenu',
  props: {
    options: null,
    icon: { default: 'mage:dots' },
    iconColor: { default: 'text-black-neutral' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'change', value: string): void
	(event: string): void
}), expose: any, slots: any, attrs: any }) {

const status = ref(ContextMenuStatusEnum.IDLE)
const optionsRef = ref()





function handleChosenOption(event: string) {
	emit('change', event)
	emit(event)
	status.value = ContextMenuStatusEnum.CLOSED
}

onClickOutside(optionsRef, () => {
	if (status.value === ContextMenuStatusEnum.OPENED) {
		status.value = ContextMenuStatusEnum.CLOSED
	}
})

return { __sfc: true,status, optionsRef, emit, handleChosenOption, Icon, ContextMenuStatusEnum }
}

})